import { type GeospaceCdsRegionBlock } from "@/features/map/api/getCdsMapAuthorizeKey";

export interface GeospaceBounds {
  latitudeNorth: number;
  latitudeSouth: number;
  longitudeEast: number;
  longitudeWest: number;
}

const NATIONAL_BLOCK_NAME = "全国";

/**
 * 契約範囲ブロックの集合から最大範囲の矩形を算出する。
 * 全国ブロックが含まれる場合はnullを返す。
 */
export const extractGeospaceBounds = (
  regionBlocks: GeospaceCdsRegionBlock[]
): GeospaceBounds | null => {
  if (regionBlocks.some(({ blockName }) => blockName === NATIONAL_BLOCK_NAME)) {
    return null;
  }

  let latitudeNorth: number | null = null;
  let latitudeSouth: number | null = null;
  let longitudeEast: number | null = null;
  let longitudeWest: number | null = null;

  for (const block of regionBlocks) {
    const {
      latitudeNorth: north,
      latitudeSouth: south,
      longitudeEast: east,
      longitudeWest: west,
    } = block;

    if (north != null) {
      if (latitudeNorth === null || north > latitudeNorth) {
        latitudeNorth = north;
      }
    }

    if (south != null) {
      if (latitudeSouth === null || south < latitudeSouth) {
        latitudeSouth = south;
      }
    }

    if (east != null) {
      if (longitudeEast === null || east > longitudeEast) {
        longitudeEast = east;
      }
    }

    if (west != null) {
      if (longitudeWest === null || west < longitudeWest) {
        longitudeWest = west;
      }
    }
  }

  if (
    latitudeNorth === null ||
    latitudeSouth === null ||
    longitudeEast === null ||
    longitudeWest === null
  ) {
    return null;
  }

  return {
    latitudeNorth,
    latitudeSouth,
    longitudeEast,
    longitudeWest,
  };
};
